export default __webpack_public_path__ + "static/media/banner1.05258f71.jpg";